<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="printOptionsContainer">
  <div class="modal-header">
    <div class="modal-title" [xdaTranslate]="param.label"></div>
  </div>
  <div class="modal-body">
    <div class="list">
      <ul>
        @for (option of param.options; track option) {
          <li>
            <button
              type="button"
              class="xrx-btn btn-secondary btn medium"
              [ngClass]="{
                'icon-button': option.icon && option.glyph === undefined,
                'glyph-btn': option.glyph,
                selected:
                  selectedValue.key === option.key &&
                  selectedValue.value === option.value,
              }"
              (click)="setValue(option)">
              @if (option.icon) {
                <span class="xrx-icon-sm {{ option.icon }}"></span>
              }
              <span [xdaTranslate]="option.key"></span>
              @if (option.glyph) {
                <span class="glyph {{ option.glyph }}"></span>
              }
            </button>
          </li>
        }
      </ul>
    </div>
    <div class="btns">
      <button
        class="xrx-btn btn-secondary btn-margin"
        (click)="activeModal.dismiss()"
        xdaTranslate>
        SDE_CANCEL
      </button>
      <button class="xrx-btn btn-primary" (click)="closeModal()" xdaTranslate>
        SDE_OK
      </button>
    </div>
  </div>
</div>
